// src/stone/illustrations/DeliveryIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var DeliveryIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "M24.8 28.059c-3.887-.553-19.478-4.36-19.478-4.36-.67-.23-1.066-.575-1.187-.814-1.217-2.438-1.436-5.376-.905-8.252C4.585 7.286 10.2 2.428 17.14 4.032c3.163.731 6.601 2.681 8.04 5.498.408.798.773 1.574 1.097 2.35.017.044.038.087.055.132.297.713.558 1.424.79 2.145.618 1.93 1.016 3.939 1.244 6.286.186 1.916.035 3.391-.341 4.515q-.001.007-.005.012c-.624 1.857-1.82 3.107-3.22 3.089"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m28.022 24.97-6.242-1.95-6.1-1.906-2.048-.64c-.686-.215-1.214-.812-1.376-1.551l-1.222-5.647c-.291-1.338.7-2.567 1.984-2.463l8.161.655 1.434.117h.002l3.664.295q.03.065.056.132c.297.713.558 1.424.79 2.145.618 1.93 1.016 3.939 1.244 6.286.187 1.915.035 3.391-.341 4.515q-.002.008-.006.013"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#F1BD38",
          d: "M13.201 6.452A4.89 4.89 0 0 0 8.27 7.958 5.84 5.84 0 0 0 6.686 2.69a4.89 4.89 0 0 0 4.93-1.505 5.83 5.83 0 0 0 1.585 5.267"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "M20.345 14.168c-.918.775-.758 1.532-.602 2.269.038.184.077.366.098.547zm0 0a1000 1000 0 0 0 2.435-2.07m-2.435 2.07 2.435-2.07m0 0 3.155.255q.327.803.599 1.608-.444.31-.9.623c-.994.683-2.015 1.384-2.948 2.183zm-1.172 10.345c.491-.622.704-1.131.783-1.552.09-.475.018-.887-.097-1.3q-.044-.156-.093-.313l-.006-.02q-.046-.148-.09-.3a3 3 0 0 1-.126-.691 1.7 1.7 0 0 1 .142-.78q.178-.392.565-.72zm0 0-4.764-1.49c.502-.348.988-.725 1.45-1.133m3.314 2.623-3.313-2.623m0 0-.33-.375.33.375Zm0 0c.283-.248.693-.634 1.018-1.102.321-.46.608-1.065.528-1.733z"
        }
      )
    ]
  }
);
var DeliveryIllustration_default = DeliveryIllustration;

export {
  DeliveryIllustration_default
};
